import { render, staticRenderFns } from "./Invhist.vue?vue&type=template&id=32ab3a97&scoped=true&"
import script from "./Invhist.vue?vue&type=script&lang=js&"
export * from "./Invhist.vue?vue&type=script&lang=js&"
import style0 from "./Invhist.vue?vue&type=style&index=0&id=32ab3a97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab3a97",
  null
  
)

export default component.exports